<div class="hour-container">
  <div class="input-wrapper relative">
    <input class="form-control" [imask]="hourMask" [formControl]="hourControl" />
    <tsq-icon
      class="absolute right-16 top-1/2 -translate-y-1/2"
      [ngClass]="disabled ? 'text-coal-tertiary cursor-not-allowed' : 'text-primary'"
      [icon]="clockIcon"
    />
  </div>

  <div *ngIf="lang !== 'pt'">
    <tsq-dropdown
      [formControl]="periodControl"
      [items]="periodOptions"
      [placeholder]="'LIBS.AM_PM'"
    />
  </div>
</div>

<label
  class="input-error-label"
  *ngIf="abstractControl.errors?.invalidHourError && !!abstractControl.value"
>
  {{ 'LIBS.VALIDATORS.INVALID_HOUR_ERROR' | translate }}
</label>

<label
  class="input-error-label"
  *ngIf="abstractControl.errors?.minHourError && !!abstractControl.value"
>
  {{ 'LIBS.VALIDATORS.MIN_HOUR_ERROR' | translate }}
</label>
